import { REDIRECT_TYPE, REDIRECT_TYPE_CODES } from 'enums/seo-shared'
import { ROUTE, ROUTE_NAME } from 'enums/routes'
import { addEndingSlash, parseUrl } from '@/utils/helpers'
import { ALLOWED_ROUTE_NAMES, MAIN_ROUTE } from 'enums/main-route'

export default async function(ctx) {
  const { route, redirect } = ctx

  const fullPath = route.fullPath || ROUTE.HOMEPAGE
  const routeName = ctx.route.name

  const existingRouteNames = Object.values(ROUTE_NAME)
  const isAllowedRoute = ALLOWED_ROUTE_NAMES.includes(routeName)

  if (
    !isAllowedRoute &&
    existingRouteNames.includes(routeName) &&
    route.path !== MAIN_ROUTE
  ) {
    redirect(REDIRECT_TYPE_CODES[REDIRECT_TYPE.MOVED_TEMPORARILY], MAIN_ROUTE)
  }

  const { address, query, hash } = parseUrl(fullPath)

  const processedFullPath = `${addEndingSlash(address)}${query}${hash}`

  if (processedFullPath !== fullPath) {
    redirect(
      REDIRECT_TYPE_CODES[REDIRECT_TYPE.MOVED_PERMANENTLY],
      processedFullPath
    )

    return
  }

  redirect()
}
